import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Icon } from 'tmt-ui-kit';

import useSocialShare from '~/utils/hooks/socials/use-social-share';

const SocialContainer = styled.div`

`;

const SocialButton = styled.div`
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
  >button, >div {
    background: none;
    border: none;
    width: 94px;
    height: 94px;
    padding: 0;
    cursor: pointer !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    >i {
      font-size: 64px;
      width: 64px;
      height: 64px;
    }
    >span {
      padding-top: 5px;
    }
  }
`;

const ButtonGroups = styled.div`
  margin: 20px 0 0;
`;

const Button = styled.a`
  text-align: center;
  border: 1px solid ${props => props.theme.blue};
  border-radius: 5px;
  color: ${props => props.theme.blue};
  width: 220px;
  padding: 10px;
  display: block;
  margin: 10px auto;

  user-select: none;
  display: inline-block;
  box-sizing: border-box;
  text-decoration: none;
  cursor: pointer;
  font-weight: 500;
  outline: none;
`;

const FacebookIcon = styled(Icon)`
  color: ${props => props.theme.facebook};
`;

const TwitterIcon = styled(Icon)`
  color: #00acee;
`;

const PinterestIcon = styled(Icon)`
  color: #c8232c;
`;

const ShareSocials = () => {
  const { openFacebook, openTwitter, openPinterest, copyToClipboard } = useSocialShare();
  return (
    <Fragment>
      <SocialContainer className="social-flex">
        <SocialButton className="social-button">
          <div onClick={openFacebook}>
            <FacebookIcon name="facebook" />
            <span>Facebook</span>
          </div>
          <div onClick={openTwitter}>
            <TwitterIcon name="twitter" />
            <span>Twitter</span>
          </div>
        </SocialButton>
        <SocialButton className="social-button">
          <div onClick={openPinterest}>
            <PinterestIcon name="pinterest" />
            <span>Pinterest</span>
          </div>
        </SocialButton>
      </SocialContainer>
      <ButtonGroups className="button-group">
        <Button onClick={copyToClipboard}>
          Copy link
        </Button>
        <Button href="mailto:someone@example.com">
          Send email
        </Button>
      </ButtonGroups>
    </Fragment>
  );
};

export default ShareSocials;
